module.exports = __webpack_public_path__ + "img/logoline.4d815a58.webp";